import { useEffect, useState } from 'react';
import { Message, Segment } from 'semantic-ui-react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Loader from '../../../../loader';
import { ROLES } from '../../../../../constnats/user';
import AuthService from '../../../../../service/auth';
import TableUpdatesRepo from '../../../../../utils/repository/tableUpdatesRepo';
import type { ArchivedReviewChangesResponseType } from '../../../../../utils/repository/tableUpdatesRepo/schemas';
import FinancialReportChanges from '../financialReportChanges';

type ArchivedReviewChangesProps = {
    reviewId: number | string;
    notes?: string | null;
    restricted?: boolean;
};

function ArchivedReviewChanges({ reviewId, notes, restricted }: ArchivedReviewChangesProps) {
    const [reviewChanges, setReviewChanges] = useState<ArchivedReviewChangesResponseType | null>(null);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let active = true;
        setReviewChanges(null);
        setFailed(false);
        TableUpdatesRepo.getReviewChanges(reviewId, (response: ArchivedReviewChangesResponseType) => {
            if (active) {
                setReviewChanges(response);
            }
        }, () => {
            if (active) {
                setFailed(true);
            }
        });
        return () => { active = false; };
    }, [reviewId]);

    if (failed) {
        return <Message error>Unable to load review changes.</Message>;
    }
    if (!reviewChanges) {
        return <Loader />;
    }

    const reportChanges = reviewChanges.mistakeChanges || reviewChanges.remediationChanges;
    const displayedChangeType = reviewChanges.mistakeChanges ? 'Mistake Changes' : 'Remediation Changes';

    return (
        <>
            {notes && (
                <Segment>
                    <b>Notes:</b>
                    <div className="review-notes-markdown">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>{notes}</ReactMarkdown>
                    </div>
                </Segment>
            )}
            <FinancialReportChanges
                title={`Review Changes${reportChanges && AuthService.hasAnyGlobalRole([ROLES.ADMIN]) ? ` (${displayedChangeType})` : ''}`}
                reportChanges={reportChanges}
                restricted={restricted}
            />
        </>
    );
}

export default ArchivedReviewChanges;
